<template>
  <van-col style="width: 100%; background-color: #f7f7f7;">
    <div class="person-title">
      <div class="person-line"></div>
      <div class="person-text">{{getTitle()}}</div>
    </div>


  
    <van-form @submit="onSubmit" style="margin-top: 20px;" :model="dataform">
      <van-field v-model="dataform.name" label="姓名" placeholder="请输入姓名" :rules="[{ required: true}]" input-align="right" clearable/>
      <van-field v-model="dataform.identityCard" label="身份证号" placeholder="请输入身份证号" maxlength="18" :rules="[{ required: true}]" input-align="right" clearable/>
      <van-field :value="sexValue" label="性别" input-align="right" placeholder="请选择性别" right-icon="arrow" :rules="[{ required: true }]" @click="onClickSex" readonly clearable/>
      <van-field v-model="dataform.account" label="手机号" type="tel" placeholder="请输入手机号" maxlength="11" :rules="[{ required: true}]" input-align="right" clearable/>
      <div style="padding: 60px 16px;">
        <van-button round block type="info" native-type="submit">注册</van-button>
       </div>
    </van-form>

    <van-action-sheet v-model="showSexSheet" :actions="actions" @select="onSelect" />

  </van-col>
</template>

<script>

import request from "@/utils/request";
import { Toast } from 'vant';
import user from "@/utils/user";
import { Dialog } from 'vant';

export default {
   props: {
    invitedid: {
      type: String,
      default: ""
    },
    isenterprise: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      sexValue: '',
      isCountFinish: true,
      showSexSheet: false,
      actions: [{ name: '男', id: 0 }, { name: '女', id: 1 }],
      dataform: {
        firmId: "",
        smallProgramOpenId: "",
        publicAccountOpenId: "",
        weChatUnionid: "",
        img: "",
        account: "",
        pwd: "",
        name: "",
        duty: 1,
        status: 0,
        identityCard: "",
        sex: undefined,
        departmentId: "",
        enterpriseName: "",
        enterpriseCode: "",
        salesmanId: "",
        remark: "",
      },
    };
  },
  created() {
    console.log("==============>", this.invitedid)
   if (!user.isLogin()) {
      Dialog.alert({
        message: '请先关注税银报告公共号',
      }).then(() => {
        // on close
      });
    }
  },
  methods: {
    getTitle() {
      return this.isenterprise ? "注册加入团队 " : "个人注册 "
    },
    onClickSex() {
      this.showSexSheet = true;
    },
     onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.showSexSheet = false;
      this.sexValue = item.name;
      this.dataform.sex = item.id;
    },
    onClickStatrCount() {
      this.$refs.countDown.reset();
      this.isCountFinish = false;
    },
    onClickCountFinish() {
      this.isCountFinish = true;
    },
    onSubmit() {
      if(this.isenterprise) {
        this.dataform.firmId = this.invitedid
        this.dataform.duty = 2
        this.dataform.status = 5
      }
      const tempDataForm = Object.assign({}, this.dataform);
      request.post("/User/AccountMng/Create", tempDataForm).then(() => {
          Toast("注册成功");
          this.$router.replace({ name: 'home' });
      }).catch(() => {
      
      });
    },

  }
};
</script>

<style lang="less">
.person-title {
  display: flex;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.person-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.person-text {
  color: #333;
  margin-left: 6px;
}

.person-content {
  padding-right: 20px;
  text-align: right;
  color: #333;
  border: none;
  width: 95%;
}
</style>
